import styled, { css } from 'styled-components';
import { darken } from 'polished';
import DatePicker from 'react-datepicker';

export const Container = styled.div`
  padding: 20px;
  color: #e9ecef;
  overflow-y: auto;
  height: 100%;
  width: 100%;
  &::-webkit-scrollbar-track {
    background-color: #2a3142;
  }
  &::-webkit-scrollbar {
    width: 6px;
    background: #eee;
  }
  &::-webkit-scrollbar-thumb {
    background: #eee;
  }

  h4 {
    color: #e9ecef;
    font-size: 18px;
    line-height: 30px;
    font-weight: 700;
  }

  span {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    font-family: 'Roboto', sans-serif;
  }

  textarea {
    border: 1px solid rgba(255, 255, 255, 0.07);
    border-radius: 4px;
    color: #dee2e6;
    background: #323a4e;
    padding: 10px 20px;
    height: 400px;
    width: 100%;
    resize: none;
    margin-top: 0.8rem;

    &::-webkit-scrollbar-track {
      background-color: #2a3142;
    }
    &::-webkit-scrollbar {
      width: 6px;
      background: #eee;
    }
    &::-webkit-scrollbar-thumb {
      background: #eee;
    }
  }

  label {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    font-family: 'Roboto', sans-serif;
    font-weight: 700;
  }
`;

export const Wrapper = styled.div`
  display: flex;

  /* Parte responsiva */
  @media (max-width: 1200px) {
    flex-direction: column;
  }
`;

export const Label = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  textarea {
    color: #fff;
    font-size: 14px;
  }

  input {
    width: 100%;
  }

  span {
    margin-bottom: 10px;
  }
  ${props =>
    props.small &&
    css`
      textarea {
        height: 200px;

        &::placeholder {
          color: #fff;
        }
      }
    `}
`;

export const Combo = styled.div`
  margin-top: 20px;
  height: 100%;
  overflow-y: auto;
  &::-webkit-scrollbar-track {
    background-color: #2a3142;
  }
  &::-webkit-scrollbar {
    width: 6px;
    background: #eee;
  }
  &::-webkit-scrollbar-thumb {
    background: #eee;
  }
`;

export const DS = styled(DatePicker)`
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 4px;
  color: #dee2e6;
  background: #323a4e;
  padding: 15px 5px;
  padding-left: ${p => (p.icon ? '2.5rem' : '1.6rem')};
  /* margin: 20px 0; */
`;

export const Pergunta = styled.div`
  margin-bottom: 1.5rem;
  strong {
    margin-bottom: 0.8rem;
    color: rgba(255, 255, 255, 0.7);
    display: block;
  }

  select {
    width: 100%;
    background: #323a4e;
    color: #fff;
    height: 50px;
    font-size: 14px;
    padding: 10px;
    border: 1px solid rgba(255, 255, 255, 0.07);
    border-radius: 4px;
  }
`;

export const Organizador = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  height: 400px;
  overflow-x: auto;
  &::-webkit-scrollbar-track {
    background-color: #2a3142;
  }
  &::-webkit-scrollbar {
    width: 6px;
    background: #eee;
  }
  &::-webkit-scrollbar-thumb {
    background: #eee;
  }
`;

export const Historico = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 20px;
  b {
    display: inline-block;
    background: rgba(255, 255, 255, 0.2);
    width: 15px;
    height: 15px;
    border-radius: 50%;
    position: relative;
  }

  div {
    margin-left: 20px;
    flex: 1;

    time {
      font-size: 12px;
      font-style: italic;
    }

    p {
      font-size: 16px;
      margin-top: 10px;
      font-style: italic;
      margin-bottom: 10px;
      word-wrap: break-word;
    }

    h4 {
      color: #8a92de;
      display: flex;
      align-items: center;
    }

    span {
      font-weight: bold;
      margin-left: 5px;
      margin-top: 4px;
    }

    h3 {
      font-size: 12px;

      span {
        font-size: 12px;
      }
    }

    audio {
      margin-top: 15px;
    }
  }

  & + div {
    padding-top: 20px;
    border-top: 1px solid rgba(255, 255, 255, 0.09);
  }
`;

export const Drag = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const DragBTN = styled.div`
  button {
    background: #626ed4;
    border: 0;
    border-radius: 4px;
    padding: 10px;
    color: #fff;
    transition: background 0.3s ease-in-out;

    &:hover {
      background: ${darken(0.04, '#626ed4')};
    }

    & + button {
      margin-left: 10px;
    }
  }
`;

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  text-align: center;

  span {
    color: #fff;
    padding: 10px 0;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;
  }
`;

export const ModalMenus = styled.div`
  display: flex;
  justify-content: center;
  align-items: stretch;
  margin-top: 10px;
  width: 100%;

  button {
    flex: 1;
    background: #626ed4;
    border: 0;
    padding: 15px 0;
    border-radius: 4px;
    color: #fff;
  }
`;
